module.exports = __webpack_public_path__ + "static/il-start-bc30ac9b524d25b343acb79c9219c51e.svg";